import React, { useEffect } from "react";
import { useThrottle } from "./throttle";

export const useInfiniteScroll = (
  rootRef: React.RefObject<HTMLElement>,
  fetchNextPage: () => void,
  hasNextPage: boolean,
  isFetchingNextPage: boolean,
  invokeHook: boolean = true,
  isVirtualizationUsed: boolean = false
): void => {
  const scrollingCallBack = event => {
    if (hasNextPage && !isFetchingNextPage && invokeHook) {
      const bodyRect = rootRef.current?.getBoundingClientRect();

      if (isVirtualizationUsed) {
        const scrollingElement = event.target;

        if (
          scrollingElement.scrollTop > 20 &&
          scrollingElement.scrollTop + bodyRect?.height * 4 >
            scrollingElement.scrollHeight
        ) {
          fetchNextPage();
        }
      } else if (
        bodyRect?.height + bodyRect?.top - window.innerHeight <
        window.innerHeight
      ) {
        fetchNextPage();
      }
    }
  };

  const handleScroll = useThrottle(scrollingCallBack, 166, {
    leading: false,
    trailing: true
  });

  useEffect(() => {
    document.addEventListener("scroll", handleScroll, {
      once: false,
      capture: true,
      passive: false
    });

    return () => {
      document.removeEventListener("scroll", handleScroll);
    };
  }, []);
};
